import { useState, useEffect } from 'react'
import { trackEvent } from '@/lib/trackEvent'
import Navbar from '@/components/shared/Navbar'
import { axios } from '@/services/api/axiosInstance'
import { endpoints } from '@/services/api/endpoints'
import { toast } from 'sonner'

const LeaderBoard = () => {
  const [leaderBoard, setLeaderBoard] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getLeaderBoard()
  }, [])

  const getLeaderBoard = async () => {
    try {
      setLoading(true)
      const response = await axios.get(endpoints.userLeaderBoard.url)
      const fetchedLeaderBoard = response.data.data.leaderboard
      setLeaderBoard(fetchedLeaderBoard)
    } catch (err: any) {
      console.error('Error fetching leaderboard:', err)
      toast.error('Failed to fetch leaderboard. Please try again.')
      trackEvent('Leaderboard Fetch Error', { error: err?.message })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Navbar />
      <main className="custom-scrollbar relative flex h-[calc(100dvh-64px)] flex-col gap-2 overflow-y-auto py-4 lg:px-4">
        {loading ? (
          <div className="flex size-full items-center justify-center">
            <div className="size-20 animate-pulse">
              <img src="/logo.png" alt="Loading" className="size-12" />
            </div>
          </div>
        ) : (
          <table className="min-w-full border border-white/10 text-white">
            <thead className="rounded-lg bg-foreground text-left">
              <tr>
                {['Rank', 'Creator Name', 'Total Plays', 'Number of Games'].map(
                  (header) => (
                    <th scope="col" key={header} className="p-2 font-medium">
                      {header}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {leaderBoard?.map((game: any, index: number) => (
                <tr
                  key={index}
                  className="border-b border-white/10 [&>td]:px-2 [&]:last:border-none"
                >
                  <td>{index + 1}</td>
                  <td className="flex items-center justify-center gap-2 p-2 capitalize">
                    <img
                      className="size-6 rounded-full"
                      onError={(e: any) => {
                        e.target.onerror = null
                        e.target.src = 'https://github.com/shadcn.png'
                      }}
                      src={game.profile_image}
                      alt={game?.player_name}
                    />
                    <span className="flex-1">{game.player_name}</span>
                  </td>
                  <td>{game.total_views}</td>
                  <td>{game.total_published_games}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </main>
    </>
  )
}

export default LeaderBoard
